function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M13.62 0H3.462a.57.57 0 0 0-.407.172L.17 3.11A.591.591 0 0 0 0 3.525v15.89A.58.58 0 0 0 .575 20H13.62a.58.58 0 0 0 .575-.586V.586A.58.58 0 0 0 13.62 0zM2.877 9.805h3.07a.58.58 0 0 1 .575.586.58.58 0 0 1-.575.586h-3.07a.58.58 0 0 1-.575-.586.58.58 0 0 1 .575-.586zm8.44 7.03H8.249a.58.58 0 0 1-.575-.585.58.58 0 0 1 .575-.586h3.07a.58.58 0 0 1 .575.586.58.58 0 0 1-.575.586zm0-2.929h-8.44a.58.58 0 0 1-.575-.586.58.58 0 0 1 .575-.586h8.44a.58.58 0 0 1 .576.586.58.58 0 0 1-.575.586z"
});

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.202a19c5.svg";
export { ForwardRef as ReactComponent };